import { useLocation } from "react-router-dom"

//a simplified way to grab a parameter from the URL
export const useRoutingParameter = (routeName: string) => {
    const location = useLocation()
    const searchParams = new URLSearchParams(location.search)
    const param = searchParams.get(routeName)

    return param
}
